// ---------------------------------------------------------------------------
// Onboarding Progress (V2 Doc 41)
// ---------------------------------------------------------------------------

import { pgTable, uuid, varchar, text, integer, boolean, jsonb, timestamp, index } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

export const onboardingProgress = pgTable(
  "onboarding_progress",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    userId: text("user_id").notNull(),
    persona: varchar("persona", { length: 30 }).notNull(), // owner | agency | team_member | client
    steps: jsonb("steps").$type<Array<{
      id: string;
      title: string;
      status: "pending" | "completed" | "skipped";
      completedAt?: string;
    }>>().notNull().default([]),
    completionPercent: integer("completion_percent").notNull().default(0),
    sampleDataActive: boolean("sample_data_active").notNull().default(false),
    featureRevealLevel: integer("feature_reveal_level").notNull().default(1),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_onboarding_tenant_user").on(table.tenantId, table.userId),
  ],
);
